import ApiResponse from '@/models/ApiResponse'
import { Comment } from '@/models/Posts'
import { get } from '@/utils/axios'

interface Params {
  page: number
  page_size: number
  lang: string
}

const fetchPostComments = async (url: string, params?: Partial<Params>) => {
  try {
    return await get<ApiResponse<Comment>>(url, params)
  } catch (error) {
    console.error(error)
  }
  return null
}

export default fetchPostComments
